module.exports = __webpack_public_path__ + "img/Desk Stationary A30.8fc4cbf3.jpg";